import Axios, { AxiosResponse } from "axios";
import { UrlParam } from "../../constants/urlParams";
import nonVSSpacesBase from "./nonVSSpacesBase";
import { SpaceConfig } from "./spaceConfig";
import { SpaceId } from "./spaceIds";
import { UnknownSlugWorkaround } from "./spacesBase";

interface Status {
    health: string;
    message: string;
}

interface Geography {
    id: string;
    name: string;
    health: string;
}

interface Service {
    id: string;
    geographies: Geography[];
}

interface HealthResponse {
    lastUpdated: Date;
    status: Status;
    services: Service[];
}

const spaceAdo: SpaceConfig = {
    ...nonVSSpacesBase,
    id: SpaceId.Ado,
    displayName: "Azure DevOps",
    slug: UnknownSlugWorkaround,
    spaceTag: { type: "tag", value: "azure-devops" },
    reportProblemConfig: {
        ...nonVSSpacesBase.reportProblemConfig,
        descriptionPlaceholder: "Share details on reproducing the problem, including screenshots, error messages, and any activity IDs related to your issue. Feel free to include a link to related discussions. \n\nYour initial post will be public; attachments and logs will be available only to Microsoft. After posting, any additional confidential information can be added as a private comment, visible only to Microsoft. ",
        healthStatus: async () => {
            try {
                const response: AxiosResponse<HealthResponse> = await Axios.get('https://status.dev.azure.com/_apis/status/health');
                if (response.status === 200 && response.data?.status?.health === "healthy") {
                    return {
                        borderColor: "green",
                        icon: "Accept",
                        message: "Azure DevOps services are healthy.",
                        linkText: "View status or report potential outage",
                        linkUrl: "https://status.dev.azure.com/",
                    }
                }

                return {
                    borderColor: "var(--color-error)",
                    icon: "Warning",
                    message: "Azure DevOps is experiencing an issue.",
                    linkText: "View status or report potential outage",
                    linkUrl: "https://status.dev.azure.com/",
                }
            } catch {
                console.error("Failed to get Azure DevOps health status.");
                return null;
            }
        },
    },
    reportSuggestionConfig: {
        ...nonVSSpacesBase.reportSuggestionConfig,
    },
    accentColor: "#0078d4", // Azure blue
};

export default spaceAdo;
